/**
 * Bliss client surfaces never use slate navy (#1E2532). Legacy CSS still
 * references --color-navy; these tokens remap it to black / espresso / cream.
 */

export const BLISS_INK = '#2e2418'
export const BLISS_INK_MID = '#3d3428'
export const BLISS_CREAM = '#f4efe6'
export const BLISS_CHARCOAL = '#0f0f0f'
export const BLISS_BLACK = '#000000'

export function isBlissHostname(hostname?: string | null): boolean {
  const h = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
  return h.includes('blissbunkbeds') || h.includes('.bliss.')
}

/** Quote funnel, Bliss Basic, proposal links — light parchment UI. */
export function isBlissClientLightSurface(hostname?: string | null, pathname?: string): boolean {
  const h = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
  const p = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '')
  return (
    h.startsWith('quote.') ||
    h === 'quote.blissbunkbeds.com' ||
    h.startsWith('basic.') ||
    h === 'basic.blissbunkbeds.com' ||
    h.startsWith('design.') ||
    h === 'design.blissbunkbeds.com' ||
    p.startsWith('/design') ||
    p.startsWith('/quote-approve/') ||
    p.startsWith('/p/') ||
    p === '/quote' ||
    p === '/basic' ||
    p === '/options' ||
    p.startsWith('/basic-admin')
  )
}

/** Remap legacy --color-navy (and related) after global theme bootstrap. */
export function applyBlissClientColorTokens(hostname?: string | null, pathname?: string): void {
  if (typeof document === 'undefined') return
  const root = document.documentElement

  if (isBlissClientLightSurface(hostname, pathname)) {
    root.style.setProperty('--color-navy', BLISS_INK)
    root.style.setProperty('--color-charcoal', BLISS_INK_MID)
    root.style.setProperty('--color-charcoal-light', '#5c4f3f')
    document.body.style.backgroundColor = BLISS_CREAM
    const mount = document.getElementById('root')
    if (mount) mount.style.backgroundColor = BLISS_CREAM
    return
  }

  if (isBlissHostname(hostname)) {
    root.style.setProperty('--color-navy', BLISS_BLACK)
    root.style.setProperty('--color-charcoal', BLISS_CHARCOAL)
    root.style.setProperty('--color-charcoal-light', '#1a1a1a')
    document.body.style.backgroundColor = BLISS_BLACK
    const mount = document.getElementById('root')
    if (mount) mount.style.backgroundColor = BLISS_BLACK
  }
}
